export default "__VITE_ASSET__62b1ddcb__"